import { createFileRoute } from "@tanstack/react-router";
import CardSignPage from "@/site/pages/card-sign";

/**
 * The group-card sign surface (PRD 05 §8.2, legacy `/card/sign/edit/<magic_link>`).
 * The token IS the credential — public route, simple header/footer chrome (the old
 * sign page kept the site header, unlike the chromeless read page).
 */
export const Route = createFileRoute("/s/$signToken")({
  component: CardSignPage,
});
